import { cva, type VariantProps } from 'class-variance-authority';

export const progressRootVariants = cva(['w-full'], {
  variants: {
    size: {
      sm: 'h-1',
      md: 'h-2',
      lg: 'h-3',
    },
  },
});

export const progressBaseVariants = cva([
  'relative',
  'overflow-hidden',
  'rounded-full',
  'bg-gray-200',
  'dark:bg-gray-800',
  'w-full',
  'h-full',
]);

export const progressIndicatorVariants = cva(
  [
    'h-full',
    'w-full',
    'rounded-full',
    'transition-transform',
    'duration-300',
    'ease-out',
    'origin-left',
  ],
  {
    variants: {
      color: {
        primary: 'bg-blue-500',
        success: 'bg-green-500',
        warning: 'bg-orange-500',
        error: 'bg-red-500',
        neutral: 'bg-gray-500',
      },
    },
  },
);

export type KaProgressSize = NonNullable<VariantProps<typeof progressRootVariants>['size']>;
export type KaProgressColor = NonNullable<VariantProps<typeof progressIndicatorVariants>['color']>;
